import React from 'react'
import useFetch from "../hooks/useFetch";
import {Col, Container, Row} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import parse from 'html-react-parser';



export default function Archiv( { archiv_id }) {

    const { loading, error, data } = useFetch(`https://steadfast-festival-dd089030c4.strapiapp.com/api/archivs/${archiv_id}?populate=*`, {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    if (loading) return <p>loading...</p>
    if (error) return <p>Error :(</p>

    console.log(data)


    return(
        <div>
            <Container fluid="md">
                <Row>
                    <Col>
                        <div style={{float: "left", marginBottom: 20, marginTop: 30}}>
                            <h1>{data.data.Title}</h1>
                        </div>

                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div style={{float: "left", marginBottom: 20}}>
                            <Tabs
                                defaultActiveKey="Teams"
                                transition={false}
                                id="noanim-tab-example"
                                className="mb-3"
                            >
                                {data.data.Teams && <Tab eventKey="Teams" title="Teams">
                                    {data.data.Teams && parse(data.data.Teams) }
                                </Tab>}
                                {data.data.Vorrunde && <Tab eventKey="Vorrunde" title="Vorrunde">
                                    {data.data.Vorrunde && parse(data.data.Vorrunde) }
                                </Tab>}
                                {data.data.Achtelfinale && <Tab eventKey="Achtelfinale" title="Achtelfinale">
                                    {data.data.Achtelfinale && parse(data.data.Achtelfinale) }
                                </Tab>}
                                {data.data.Viertelfinale && <Tab eventKey="Viertelfinale" title="Viertelfinale">
                                    {data.data.Viertelfinale && parse(data.data.Viertelfinale) }
                                </Tab>}
                                {data.data.Halbfinale && <Tab eventKey="Halbfinale" title="Halbfinale">
                                    {data.data.Halbfinale && parse(data.data.Halbfinale) }
                                </Tab>}
                                {data.data.Finale && <Tab eventKey="Finale" title="Finale">
                                    {data.data.Finale && parse(data.data.Finale) }
                                </Tab>}

                            </Tabs>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}